import { Injectable } from '@angular/core'; 
import { UserService } from './user.service';


@Injectable()
export class PaypalService {

	constructor(
        private userService: UserService
    ) { }


    addPaypalScript(){
		//this.addScript = true;
		return new Promise((resolve,reject)=>{
		let scripttagElement = document.createElement('script');
		scripttagElement.src = "https://www.paypalobjects.com/api/checkout.js";
		scripttagElement.onload = resolve;
		document.body.appendChild(scripttagElement);
		})
    }
    
}



// WEBPACK FOOTER //
// ./src/app/services/paypal.service.ts